class ProductRating extends HTMLElement {
  connectedCallback() {
    try {
      const data = JSON.parse(this.querySelector("script").textContent);
      if (!data.number_of_reviews || data.number_of_reviews === 0) return;
      const rating = parseFloat(data.average_rating);
      this.innerHTML = `
        <div class="flex items-center gap-1">
          <svg class="h-4 w-4 fill-current text-secondary" viewBox="0 0 20 20">
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.957a1 1 0 00.95.69h4.162c.969 0 1.371 1.24.588 1.81l-3.37 2.448a1 1 0 00-.364 1.118l1.287 3.957c.3.921-.755 1.688-1.54 1.118l-3.37-2.448a1 1 0 00-1.176 0l-3.37 2.448c-.784.57-1.838-.197-1.539-1.118l1.287-3.957a1 1 0 00-.364-1.118L2.063 9.384c-.783-.57-.38-1.81.588-1.81h4.162a1 1 0 00.95-.69l1.286-3.957z"/>
          </svg>
          <span class="text-sm font-medium opacity-60">${rating.toFixed(1)}</span>
        </div>
      `;
    } catch (e) {
    }
  }
}
customElements.define("product-rating", ProductRating);
